import {connect} from 'react-redux';

import BaseURLChanger from '../../general/components/URLChanger';

const mapStateToProps = (state, {buildURL}) => {
    const {language, regionID, productID, offset, index, resolution} = state;

    return {
        url: buildURL(state),
        data: {
            language,
            regionID,
            productID,
            offset,
            index,
            resolution,
        },
    };
};

export default connect(mapStateToProps)(BaseURLChanger);
